import { Link } from "react-router-dom";

export default function ArticlePreview() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
          <div>
            <span className="text-xs font-medium text-secondary-600 uppercase tracking-wider">
              SEO Insights
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-1 leading-tight">
              Latest Sheets
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            Expert guides and analysis on using spreadsheet intelligence for smarter shopping decisions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <div className="md:col-span-1 bg-foreground-900 rounded-2xl overflow-hidden group cursor-pointer">
            <Link to="/article/gtbuy-spreadsheet-guide" className="block h-full">
              <div className="relative h-48 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20alongside%20fashion%20product%20images%20on%20screen%20minimal%20desk%20setup%20with%20coffee%20cup%20and%20plant%20warm%20ambient%20lighting%20professional%20editorial%20photography%20clean%20aesthetic&width=600&height=400&seq=gtbuy-article-main&orientation=landscape"
                  alt="GTBuy Spreadsheet shopping guide"
                  title="GTBuy Spreadsheet Guide"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 to-transparent"></div>
              </div>
              <div className="p-5">
                <span className="text-xs font-medium text-accent-400 bg-accent-500/10 px-2 py-1 rounded-full">
                  Guide
                </span>
                <h3 className="font-heading text-lg font-bold text-background-50 mt-3 leading-snug">
                  The Complete GTBuy Spreadsheet Guide for Smarter Shopping in 2026
                </h3>
                <p className="text-sm text-background-50/60 mt-2 line-clamp-2">
                  Learn how to use the GTBuy spreadsheet system to compare products, find the best deals, and make data-driven shopping decisions.
                </p>
                <div className="mt-4 flex items-center gap-2 text-accent-400 text-sm">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden group cursor-pointer">
            <Link to="/article/gtbuy-spreadsheet-guide" className="block h-full">
              <div className="h-40 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Clean%20fashion%20product%20comparison%20display%20with%20three%20pairs%20of%20minimal%20white%20sneakers%20side%20by%20side%20on%20cream%20surface%20soft%20lighting%20editorial%20product%20photography%20minimal%20aesthetic&width=600&height=400&seq=gtbuy-article-2&orientation=landscape"
                  alt="Product comparison guide"
                  title="GTBuy product comparison"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs font-medium text-secondary-600 bg-secondary-100 px-2 py-1 rounded-full">
                  Comparison
                </span>
                <h3 className="font-medium text-foreground-900 mt-3 leading-snug">
                  Best Budget Sneakers: A Spreadsheet Comparison Approach
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2">
                  How to use spreadsheet intelligence to find the best sneaker deals across multiple retailers.
                </p>
                <div className="mt-3 text-xs text-accent-600 flex items-center gap-1">
                  <span>Read More</span>
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </div>
              </div>
            </Link>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden group cursor-pointer">
            <Link to="/article/gtbuy-spreadsheet-guide" className="block h-full">
              <div className="h-40 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Hidden%20surprise%20shopping%20deals%20concept%20with%20gift%20box%20and%20fashion%20accessories%20on%20cream%20background%20soft%20natural%20lighting%20editorial%20photography%20warm%20aesthetic%20minimal%20composition&width=600&height=400&seq=gtbuy-article-3&orientation=landscape"
                  alt="Hidden deals shopping guide"
                  title="GTBuy hidden deals guide"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2 py-1 rounded-full">
                  Deals
                </span>
                <h3 className="font-medium text-foreground-900 mt-3 leading-snug">
                  Hidden Deals: Using GTBuy Sheet to Uncover Best Prices
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2">
                  Discover how the GTBuy spreadsheet system reveals hidden discounts and price drops.
                </p>
                <div className="mt-3 text-xs text-accent-600 flex items-center gap-1">
                  <span>Read More</span>
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}